// extracted by mini-css-extract-plugin
module.exports = {"section":"q_q","section__head":"q_M","section__content":"q_N","ui":"q_P","ui____minimized":"q_Q"};